document.addEventListener('DOMContentLoaded', function () {
  // Solo Desktop
  if (window.innerWidth <= 1024) return;

  const mediaItems = Array.from(document.querySelectorAll('.product__media-item.pablozoom'));
  if (!mediaItems.length) return;

  // =========================
  // Recolectar imágenes
  // =========================
  const gallery = mediaItems
    .map((container) => {
      const img = container.querySelector('img');
      if (!img) return null;

      // Preferir data-zoom-src, si existe; luego currentSrc; luego src
      const srcFromSrcset = img.currentSrc || img.src;
      const zoomSrc = img.getAttribute('data-zoom-src') || srcFromSrcset || img.src;

      return {
        container,
        img,
        zoomSrc,
        alt: img.getAttribute('alt') || '',
      };
    })
    .filter(Boolean);

  if (!gallery.length) return;

  // =========================
  // Construir Lightbox una vez
  // =========================
  const ensureLightbox = () => {
    let lb = document.getElementById('pabloLightbox');
    if (lb) return lb;

    const wrapper = document.createElement('div');
    wrapper.id = 'pabloLightbox';
    wrapper.className = 'pablo-lightbox';
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.setAttribute('role', 'dialog');
    wrapper.setAttribute('aria-label', 'Galería de imágenes del producto');

    wrapper.innerHTML = `
      <div class="pablo-lightbox__top">
        <button class="pablo-lightbox__close" aria-label="Cerrar (Esc)">×</button>
      </div>

      <div class="pablo-lightbox__stage">
        <button class="pablo-lightbox__prev" aria-label="Anterior">‹</button>
        <img class="pablo-lightbox__img" alt="">
        <button class="pablo-lightbox__next" aria-label="Siguiente">›</button>
      </div>

      <div class="pablo-lightbox__bottom">
        <div class="pablo-lightbox__counter"><span class="current">1</span>/<span class="total">${gallery.length}</span></div>
      </div>
    `;
    document.body.appendChild(wrapper);
    return wrapper;
  };

  const lightbox = ensureLightbox();
  const closeBtn = lightbox.querySelector('.pablo-lightbox__close');
  const imgEl    = lightbox.querySelector('.pablo-lightbox__img');
  const prevBtn  = lightbox.querySelector('.pablo-lightbox__prev');
  const nextBtn  = lightbox.querySelector('.pablo-lightbox__next');
  const counterCurrent = lightbox.querySelector('.pablo-lightbox__counter .current');
  const stage    = lightbox.querySelector('.pablo-lightbox__stage');

  let currentIndex = 0;
  let zoomed = false;

  // =========================
  // Helpers
  // =========================
  const openLightbox = (index = 0) => {
    currentIndex = index;
    document.body.classList.add('pablo-no-scroll');
    lightbox.classList.add('open');
    lightbox.setAttribute('aria-hidden', 'false');

    loadImage(currentIndex, true);
    bindGlobalKeys(true);
  };

  const closeLightbox = () => {
    document.body.classList.remove('pablo-no-scroll');
    lightbox.classList.remove('open');
    lightbox.setAttribute('aria-hidden', 'true');
    setZoom(false);
    bindGlobalKeys(false);
  };

  const updateCounter = () => {
    counterCurrent.textContent = String(currentIndex + 1);
  };

  const preload = (i) => {
    const item = gallery[i];
    if (!item) return;
    const pre = new Image();
    pre.src = item.zoomSrc;
  };

  const loadImage = (i, withFade = false) => {
    const item = gallery[i];
    if (!item) return;

    setZoom(false); // reset zoom al cambiar de imagen

    if (withFade) {
      imgEl.classList.remove('pablo-fade-in'); // reset
      // Forzar reflow para reiniciar animación
      // eslint-disable-next-line no-unused-expressions
      imgEl.offsetHeight;
      imgEl.classList.add('pablo-fade-in');
    }

    imgEl.src = item.zoomSrc;
    imgEl.alt = item.alt || '';
    updateCounter();

    // Pre-carga vecinos
    preload(i + 1);
    preload(i - 1);
  };

  const next = () => {
    currentIndex = (currentIndex + 1) % gallery.length;
    loadImage(currentIndex, true);
  };

  const prev = () => {
    currentIndex = (currentIndex - 1 + gallery.length) % gallery.length;
    loadImage(currentIndex, true);
  };

  const setZoom = (state) => {
    zoomed = state;
    if (zoomed) {
      imgEl.classList.add('is-zoomed');
      imgEl.style.transform = `scale(${getZoomFactor()})`;
    } else {
      imgEl.classList.remove('is-zoomed');
      imgEl.style.transform = 'scale(1)';
      imgEl.style.transformOrigin = 'center center';
    }
  };

  const getZoomFactor = () => {
    // Lee --zoom-factor desde :root y convierte a número
    const z = getComputedStyle(document.documentElement).getPropertyValue('--zoom-factor').trim();
    const parsed = parseFloat(z);
    return Number.isFinite(parsed) && parsed > 1 ? parsed : 1.7;
    // Fallback a 1.7 por si no está seteado
  };

  const updateTransformOrigin = (e) => {
    if (!zoomed) return;
    const rect = imgEl.getBoundingClientRect();

    // Usamos el centro del stage como referencia del puntero
    const stageRect = stage.getBoundingClientRect();
    const x = e.clientX - stageRect.left;
    const y = e.clientY - stageRect.top;

    const xPercent = Math.max(0, Math.min(100, (x / stageRect.width) * 100));
    const yPercent = Math.max(0, Math.min(100, (y / stageRect.height) * 100));

    imgEl.style.transformOrigin = `${xPercent}% ${yPercent}%`;
  };

  const onKeyDown = (ev) => {
    if (lightbox.getAttribute('aria-hidden') === 'true') return;
    if (ev.key === 'Escape') {
      ev.preventDefault();
      closeLightbox();
      return;
    }
    if (ev.key === 'ArrowRight') {
      ev.preventDefault();
      next();
      return;
    }
    if (ev.key === 'ArrowLeft') {
      ev.preventDefault();
      prev();
      return;
    }
  };

  const bindGlobalKeys = (bind) => {
    if (bind) {
      document.addEventListener('keydown', onKeyDown);
    } else {
      document.removeEventListener('keydown', onKeyDown);
    }
  };

  // =========================
  // Eventos Lightbox
  // =========================
  prevBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    prev();
  });
  nextBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    next();
  });
  closeBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    closeLightbox();
  });

  // Cerrar al hacer clic fuera de la imagen (en el "stage")
  stage.addEventListener('click', (e) => {
    // Si clic directo sobre la imagen -> toggle zoom
    if (e.target === imgEl) {
      setZoom(!zoomed);
      if (zoomed) updateTransformOrigin(e);
      return;
    }
    // Si clic en stage pero no en botones -> cerrar
    const isBtn = e.target.closest('.pablo-lightbox__prev, .pablo-lightbox__next, .pablo-lightbox__close');
    if (!isBtn) closeLightbox();
  });

  // Pan del zoom siguiendo el mouse
  stage.addEventListener('mousemove', (e) => {
    if (!zoomed) return;
    updateTransformOrigin(e);
  });

  // Desactiva arrastre nativo de imagen
  imgEl.addEventListener('dragstart', (e) => e.preventDefault());

  // =========================
  // Hooks sobre thumbnails
  // =========================
  // Abrir lightbox al hacer clic en cualquier imagen marcada con .pablozoom
  gallery.forEach((item, idx) => {
    item.container.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openLightbox(idx);
    });

    // Mejora de puntero
    item.container.style.cursor = 'zoom-in';
  });

});
